import React, { useMemo } from 'react';
import { Input } from 'antd';

interface InputTelefoneECelularProps {
    value?: string;
    onChange?: React.ChangeEventHandler<HTMLInputElement>,
    onBlur?: React.FocusEventHandler<HTMLInputElement>,
    onSubmit?: React.FormEventHandler<HTMLInputElement>,
    placeholder?: string;
}

export const InputTelefoneECelular: React.FC<InputTelefoneECelularProps> = ({
    value = "",
    onChange,
    onBlur,
    placeholder
}) => {

    const formatValue = (inputValue: string): string => {
        inputValue = inputValue.replace(/\D/g, "");
    
        if (inputValue.length > 8) {
            inputValue = `${inputValue.slice(0, 5)}-${inputValue.slice(5, 9)}`;
        }
        else if (inputValue.length > 4) {
            inputValue = `${inputValue.slice(0, 4)}-${inputValue.slice(4)}`;
        }

        return inputValue;
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let inputValue = e.target.value;
        inputValue = formatValue(inputValue);

        if (onChange) {
            onChange({
                ...e,
                target: { ...e.target, value: inputValue }
            });
        }
    };

    return (
        <Input
             value={formatValue(value)}
             onChange={handleChange}
             onBlur={onBlur}
             placeholder={placeholder || "Telefone/Celular"}
             maxLength={15}
        />
    );
};